import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { queryHelper } from 'helpers';
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Flags, Wrapper } from './styles';

const FlagsBanner = props => {
  const {
    flagSingaporeBanner,
    flagMalaysiaBanner,
    flagHongKongBanner,
    flagPhilippinesBanner,
    flagIndonesiaBanner,
    flagThailandBanner,
  } = useStaticQuery(graphql`
    query MyFlagBannerQuery {
      flagSingaporeBanner: nodeBanner(title: {eq: "flagSingaporeBanner"}) {
        drupal_id
        title
        relationships {
          field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [WEBP]
                  layout: CONSTRAINED
                )
              }
            }
          }
        }
      }
      flagMalaysiaBanner: nodeBanner(title: {eq: "flagMalaysiaBanner"}) {
        drupal_id
        title
        relationships {
          field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [WEBP]
                  layout: CONSTRAINED
                )
              }
            }
          }
        }
      }
      flagHongKongBanner: nodeBanner(title: {eq: "flagHongKongBanner"}) {
        drupal_id
        title
        relationships {
          field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [WEBP]
                  layout: CONSTRAINED
                )
              }
            }
          }
        }
      }
      flagPhilippinesBanner: nodeBanner(title: {eq: "flagPhilippinesBanner"}) {
        drupal_id
        title
        relationships {
          field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [WEBP]
                  layout: CONSTRAINED
                )
              }
            }
          }
        }
      }
      flagIndonesiaBanner: nodeBanner(title: {eq: "flagIndonesiaBanner"}) {
        drupal_id
        title
        relationships {
          field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [WEBP]
                  layout: CONSTRAINED
                )
              }
            }
          }
        }
      }
      flagThailandBanner: nodeBanner(title: {eq: "flagThailandBanner"}) {
        drupal_id
        title
        relationships {
          field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [WEBP]
                  layout: CONSTRAINED
                )
              }
            }
          }
        }
      }
    }  
  `);

  return (
    <Wrapper>
      <Flags>
        <GatsbyImage 
          style={{gridArea: "1/1"}}
          layout="fullWidth"
          aspectRatio={3 / 1}
          image={getImage(queryHelper.getGatsbyImageData(flagSingaporeBanner))} alt=""
        />
      </Flags>
      <Flags>
        <GatsbyImage 
          style={{gridArea: "1/1"}}
          layout="fullWidth"
          aspectRatio={3 / 1}
          image={getImage(queryHelper.getGatsbyImageData(flagMalaysiaBanner))} alt=""
        />
      </Flags>
      {/*<Flags>
        <GatsbyImage 
          style={{gridArea: "1/1"}}
          layout="fullWidth"
          aspectRatio={3 / 1}
          image={getImage(queryHelper.getGatsbyImageData(flagHongKongBanner))} alt=""
        />
      </Flags>*/}
      <Flags>
        <GatsbyImage 
          style={{gridArea: "1/1"}}
          layout="fullWidth"
          aspectRatio={3 / 1}
          image={getImage(queryHelper.getGatsbyImageData(flagPhilippinesBanner))} alt=""
        />
      </Flags>
      <Flags>
        <GatsbyImage 
          style={{gridArea: "1/1"}}
          layout="fullWidth"
          aspectRatio={3 / 1}
          image={getImage(queryHelper.getGatsbyImageData(flagIndonesiaBanner))} alt=""
        />
      </Flags>
      <Flags>
        <GatsbyImage 
          style={{gridArea: "1/1"}}
          layout="fullWidth"
          aspectRatio={3 / 1}
          image={getImage(queryHelper.getGatsbyImageData(flagThailandBanner))} alt=""
        />
      </Flags>
    </Wrapper>
  );
};

export default FlagsBanner;